import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaArrowLeft } from 'react-icons/fa';
import axios from 'axios';
import './NewsDetail.css';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNewsDetail();
  }, [id]);

  const fetchNewsDetail = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/news/${id}`);
      setNews(response.data);
      setError(null);
    } catch (err) {
      console.error('Ошибка загрузки новости:', err);
      setError('Новость не найдена');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    try {
      return new Date(dateString).toLocaleDateString('ru-RU', options);
    } catch (e) {
      return dateString;
    }
  };

  const getImageUrl = (item) => {
    if (!item?.image_url) return null;
    
    if (item.image_url.startsWith('data:image')) {
      return item.image_url;
    }
    
    if (item.image_url.startsWith('/uploads')) {
      return `http://localhost:5000${item.image_url}`;
    }
    
    if (item.image_url.startsWith('http')) {
      return item.image_url;
    }
    
    return null;
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Загрузка новости...</p>
      </Container>
    );
  }

  if (error || !news) {
    return (
      <Container className="py-5 text-center">
        <Alert variant="danger">{error || 'Новость не найдена'}</Alert>
        <Button variant="primary" onClick={() => navigate('/news')}>
          Вернуться к новостям
        </Button>
      </Container>
    );
  }

  return (
    <div className="news-detail-page bg-light">
      <Container className="py-5">
        <Button
          variant="link"
          onClick={() => navigate('/news')}
          className="mb-4 text-decoration-none"
          style={{ color: '#006186' }}
        >
          <FaArrowLeft className="me-2" /> Назад к новостям
        </Button>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
            {getImageUrl(news) && (
              <div className="news-detail-image-wrapper">
                <Card.Img
                  src={getImageUrl(news)}
                  className="news-detail-image"
                  style={{ maxHeight: '400px', objectFit: 'cover', width: '100%' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}
            
            <Card.Body className="p-4 p-lg-5">
              <div className="d-flex align-items-center text-muted mb-4">
                <FaCalendarAlt className="me-2" />
                <span>{formatDate(news.date)}</span>
                {news.views_count && (
                  <span className="ms-3">Просмотров: {news.views_count}</span>
                )}
              </div>
              
              <h1 className="fw-bold mb-4" style={{ color: '#1a365d' }}>
                {news.title}
              </h1>
              
              <div className="news-content" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                {news.content ? (
                  <div dangerouslySetInnerHTML={{ __html: news.content.replace(/\n/g, '<br/>') }} />
                ) : (
                  <p className="text-muted">{news.description}</p>
                )}
              </div>
            </Card.Body>
          </Card>
        </motion.div>
      </Container>
    </div>
  );
};

export default NewsDetail;